import css from 'styled-jsx/css'
import { colors, measurements } from 'theme'

export const chartStyle = css`
  .chart-container {
    width: 100%;
    height: 20rem;
  }
  .loading-content,
  .not-content {
    display: flex;
    justify-content: center;
    border: 1px solid ${colors.border};
    padding: 1.5rem 0.5rem;
  }
  @media screen and (max-width: 992px) {
    .chart-container {
      height: 25rem;
    }
  }
`

export const controlsStyle = css`
  .form-controls-content {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-bottom: 1rem;
    width: 100%;
  }

  .form-controls-content .month {
    width: 100%;
    flex: 1;
    display: flex;
    padding: 1rem;
    padding-left: 2rem;
  }

  .form-controls-content .month .label {
    margin-right: 1rem;
  }

  .form-controls-content .range {
    width: 100%;
    flex: 1;
    padding: 1rem;
  }
  @media screen and (max-width: 992px) {
    .form-controls-content {
      flex-direction: column;
    }
    .form-controls-content .month {
      flex-direction: column;
    }
  }
`

export const custoToolTipStyles = css`
  .custom-tooltip-content {
    border: 1px solid ${colors.border};
    background-color: ${colors.alpha(colors.white, 0.7)};
    padding: 0.5rem;
    border-radius: ${measurements.borderRadius};
  }
  .custom-tooltip-content p {
    margin: 0;
  }
`
